/**
 * Portrait d'un personnage dans Firebase Storage (API modulaire), au même emplacement que pour Aria.
 */
import {getStorage, ref, uploadBytes, getDownloadURL} from 'firebase/storage';

export const MAX_PORTRAIT_BYTES = 5 * 1024 * 1024;

/**
 * Envoie l'image et renvoie son URL publique.
 * Le paramètre `v` évite que le navigateur réaffiche l'ancien portrait en cache (même chemin à chaque envoi).
 */
export const uploadPortrait = async (characterUid, file) => {
  const portraitRef = ref(getStorage(), `charactersPictures/${characterUid}.png`);
  await uploadBytes(portraitRef, file, {contentType: file.type});
  const url = await getDownloadURL(portraitRef);
  return `${url}${url.includes('?') ? '&' : '?'}v=${Date.now()}`;
};
